<div class="pages-registration-container">
  <div class="page-registration-content">
    <div class="page-registration-content-header">
      @if (logo) {
        <div class="align-center">
          <img class="public-logo img-width100" ngSrc="assets/images/{{logo}}" alt="" width="286" height="76"
               [priority]="true"/>
        </div>
      }
    </div>
    <div class="page-registration-content-body margin-top-5">
      @if(organization) {
        <p-stepper [(value)]="active">
          <p-step-list>
            <p-step [value]="1">
            <ng-template #content  let-activateCallback="activateCallback" let-value="value" let-index="index">
              <p-button class="bg-transparent border-none inline-flex flex-column gap-2 pointer" (click)="activateCallback()" pTooltip="Contact Info"
                      [ngClass]="{'active': index <= active,'surface-border': index > active}">
                      <span class="border-round border-2 w-3rem h-3rem inline-flex align-items-center justify-content-center">
                          <i class="pi pi-user"></i>
                      </span>
              </p-button>
            </ng-template>
          </p-step>
          <p-step [value]="2">
            <ng-template #content  let-activateCallback="activateCallback" let-value="value" let-index="index">
              @if(stepOneComplete) {
                <p-button class="bg-transparent border-none inline-flex flex-column gap-2 pointer" (click)="activateCallback()" pTooltip="Security"
                        [ngClass]="{'active': index <= active,'surface-border': index > active}">
                        <span class="border-round border-2 w-3rem h-3rem inline-flex align-items-center justify-content-center">
                            <i class="pi pi-lock"></i>
                        </span>
                </p-button>
              } @else {
                <p-button class="bg-transparent border-none inline-flex flex-column gap-2 pointer"  pTooltip="Security"
                        [ngClass]="{'active': index <= active,'surface-border': index > active}">
                        <span class="border-round border-2 w-3rem h-3rem inline-flex align-items-center justify-content-center">
                            <i class="pi pi-lock"></i>
                        </span>
                </p-button>
              }

            </ng-template>
          </p-step>
          @if(tenantAllowsRegistrationPayment) {
          <p-step [value]="3">
            <ng-template #content  let-activateCallback="activateCallback" let-value="value" let-index="index">
              @if(stepTwoComplete) {
                <p-button class="bg-transparent border-none inline-flex flex-column gap-2 pointer" (click)="activateCallback()" pTooltip="Billing"
                        [ngClass]="{'active': index <= active,'surface-border': index > active}">
                      <span class="border-round border-2 w-3rem h-3rem inline-flex align-items-center justify-content-center">
                          <i class="pi pi-credit-card"></i>
                      </span>
                </p-button>
              } @else {
                <p-button class="bg-transparent border-none inline-flex flex-column gap-2 pointer" pTooltip="Billing"
                        [ngClass]="{'active': index <= active,'surface-border': index > active}">
                      <span class="border-round border-2 w-3rem h-3rem inline-flex align-items-center justify-content-center">
                          <i class="pi pi-credit-card"></i>
                      </span>
                </p-button>
              }

            </ng-template>
          </p-step>
          }
          <p-step [value]="4">
            <ng-template #content  let-activateCallback="activateCallback" let-value="value" let-index="index">
              @if(stepThreeComplete) {
                <p-button class="bg-transparent border-none inline-flex flex-column gap-2 pointer" (click)="activateCallback()" pTooltip="Billing Address"
                        [ngClass]="{
                                'active': index <= active,
                                'surface-border': index > active
                            }" >
                        <span class="border-round border-2 w-3rem h-3rem inline-flex align-items-center justify-content-center">
                            <i class="pi pi-id-card"></i>
                        </span>
                </p-button>
              } @else {
                <p-button class="bg-transparent border-none inline-flex flex-column gap-2 pointer" pTooltip="Address"
                        [ngClass]="{
                                'active': index <= active,
                                'surface-border': index > active
                            }" >
                        <span class="border-round border-2 w-3rem h-3rem inline-flex align-items-center justify-content-center">
                            <i class="pi pi-id-card"></i>
                        </span>
                </p-button>
              }
            </ng-template>
          </p-step>
          <p-step [value]="5">
            <ng-template #content  let-activateCallback="activateCallback" let-value="value" let-index="index">
              @if(stepThreeComplete) {
                <p-button class="bg-transparent border-none inline-flex flex-column gap-2 pointer" (click)="activateCallback()" pTooltip="Billing Address"
                        [ngClass]="{
                                'active': index <= active,
                                'surface-border': index > active
                            }" >
                        <span class="border-round border-2 w-3rem h-3rem inline-flex align-items-center justify-content-center">
                            <i class="pi pi-id-card"></i>
                        </span>
                </p-button>
              } @else {
                <p-button class="bg-transparent border-none inline-flex flex-column gap-2 pointer" pTooltip="Complete"
                        [ngClass]="{
                                'active': index <= active,
                                'surface-border': index > active
                            }" >
                        <span class="border-round border-2 w-3rem h-3rem inline-flex align-items-center justify-content-center">
                            <i class="pi pi-check-circle"></i>
                        </span>
                </p-button>
              }
            </ng-template>
          </p-step>
        </p-step-list>




        <p-step-panels>
          <p-step-panel [value]="1">
            <ng-template #content  let-activateCallback="activateCallback">
              <app-registration-page-1 (next)="activateCallback(2); stepOneComplete = true" [registrationProfile]="registrationProfile" [organizationDetails]="organization"
                                       (updateData)="registrationProfile = $event" ></app-registration-page-1>
            </ng-template>
          </p-step-panel>
          <p-step-panel [value]="2">
            <ng-template #content  let-activateCallback="activateCallback">
              <app-registration-page-2 (next)="activateCallback(3); stepTwoComplete = true" [registrationProfile]="registrationProfile" [organizationDetails]="organization"
                                       (updateData)="registrationProfile = $event" ></app-registration-page-2>
            </ng-template>
          </p-step-panel>
          @if(tenantAllowsRegistrationPayment) {
          <p-step-panel [value]="3">
              <p-stepperPanel>

                <ng-template #content  let-activateCallback="activateCallback">
                  <app-registration-page-3 (next)="activateCallback(4); stepThreeComplete = true " [registrationProfile]="registrationProfile" [organizationDetails]="organization"
                                           (updateData)="registrationProfile = $event" ></app-registration-page-3>
                </ng-template>
              </p-stepperPanel>
          </p-step-panel>
          } @else {

          }
          <p-step-panel [value]="4">
            <ng-template #content  let-activateCallback="activateCallback">
              <app-registration-page-4 (next)="activateCallback(5); stepFourComplete = true " (updateData)="registrationProfile = $event" [registrationProfile]="registrationProfile"
                                       [organizationDetails]="organization" [tenantName]="tenant"></app-registration-page-4>
            </ng-template>
          </p-step-panel>

          <p-step-panel [value]="5">
            <ng-template #content  let-activateCallback="activateCallback">
              <app-registration-page-5  [registrationProfile]="registrationProfile" [organizationDetails]="organization"></app-registration-page-5>
            </ng-template>
          </p-step-panel>
        </p-step-panels>
      </p-stepper>
      }
<!--@else-->
<!--        <h3>We're sorry. Self-registration is not currently available for your organization.</h3>-->
<!--      }-->
    </div>
  </div>
</div>


<!--Primeng 18 way for future-->
<!--<p-stepper [value]="1" class="basis-[50rem]" [linear]="true">-->
<!--  <p-step-list>-->
<!--    <p-step [value]="1">Contact Info</p-step>-->
<!--    <p-step [value]="2">Header II</p-step>-->
<!--    <p-step [value]="3">Header II</p-step>-->
<!--  </p-step-list>-->
<!--  <p-step-panels>-->
<!--  </p-step-panels>-->
<!--</p-stepper>-->
